// This file is used in both Node.js end browser envs.
// It has .mjs extension to make ESM syntax work in Node
export default {
  primary: {
    main: '#03BCD4',
    dark: '#008BA3',
    light: '#63EFFF',
    contrastText: '#FFFFFF',
    text1: '#FFFFFF',
    text6: '#BDBDBD',
    text7: '#9E9E9E',
    text8: '#808080',
    text9: '#616161',
  },
  secondary: {
    main: '#F50056',
    dark: '#BB002E',
    light: '#FF5982',
  },
  background: {
    b1: '#000000',
    b2: '#141414',
    b3: '#191919',
    b4: '#212121',
    b5: '#272727',
    b6: '#2C2C2C',
    b7: '#333333',
    b8: '#3B3B3B',
    b9: '#414141',
    b10: '#4E4E4E',
    b11: '#373737',
  },
  error: {
    main: '#F44336',
    dark: '#D32F2F',
    light: '#E57373',
    alert: '#EA6E52',
  },
  success: {
    main: '#4CAF50',
    dark: '#388E3C',
    light: '#88DA8B',
    bright: '#75DB29',
  },
  warning: {
    main: '#FFC107',
    dark: '#DA8F0F',
    light: '#FFE679',
    bright: '#FFA500',
  },
  info: {
    main: '#239EFF',
    dark: '#117ED4',
    light: '#7CC5FF',
  },
  charts: {
    background: '#FFFFFF',
    gaugeArrow: '#2a2e2e',
  },
  pastel: {
    p1: '#A92E26',
    p2: '#E06C92',
    p3: '#801797',
    p4: '#C336F0',
    p5: '#9078C8',
    p6: '#29388E',
    p7: '#77B5F1',
    p8: '#38818D',
    p9: '#91C9C4',
    p10: '#62893D',
    p11: '#A6CA72',
    p12: '#EEAB46',
    p13: '#EE7850',
    p14: '#F3AE96',
    p15: '#896F65',
    p16: '#7D909B',
  },
};
